import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {HOTB} from "../../HOTB";
import {SymbolsList} from "../../reels/GameSymbol";

export class AvalancheResultPresentation implements FlowStatePresentation {
    private _controller: FlowStateController;
    private _tl: TimelineLite;

    public start(controller: FlowStateController): void {
        this._controller = controller;

        this._tl = new TimelineLite({
            onComplete: (): void => {
                controller.setSkipCallback();
                this.completePresentation(controller);
            }
        });

        this._tl.add((): void => {
            controller.setSkipCallback((): void => {
                this.skip();
            });
        });

        this._tl.add((): void => {
            HOTB.topReel.onGameResult();
            HOTB.leftReel.onGameResult();
            HOTB.rightReel.onGameResult();
        });

        this._tl.add([
            HOTB.reelArea.fillUp(),
            (): void => {
                if (!this.isLaunchInMainReel()) {
                    HOTB.waysCounter.updateFinalWaysCounter();
                }
            }
        ]);
    }

    private isLaunchInMainReel(): boolean {
        let flag: boolean = false;

        if (HOTB.model.data.mode.includes("AVALANCHE")) {
            flag = HOTB.model.data.symbolsAfterAvalanchePrevSpin.some(row => row.includes(SymbolsList.LAUNCH));
        }
        return flag;
    }

    private completePresentation(flowStateController: FlowStateController): void {
        this._tl.kill();
        flowStateController.finish();
    }

    private skip(): void {
        this._tl.timeScale(2);
    }
}